export const DAY_ORDER = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const DAY_ABBR: Record<string, string> = {
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun',
};

export type DayItem = { label: string; value: string };

export const DAY_OF_WEEK_ITEMS: DayItem[] = [
  { label: 'Monday', value: 'MON' },
  { label: 'Tuesday', value: 'TUE' },
  { label: 'Wednesday', value: 'WED' },
  { label: 'Thursday', value: 'THU' },
  { label: 'Friday', value: 'FRI' },
  { label: 'Saturday', value: 'SAT' },
  { label: 'Sunday', value: 'SUN' },
];

export type CoverageBlock = {
  daysOfWeek: string[];
  startTime: string;
  endTime: string;
};

export type TeamCoverageEntry = {
  id: string;
  teamId: string;
  teamLabel: string;
  coverageBlocks: CoverageBlock[];
};

// Input: day codes e.g. ['MON','WED','FRI']. Output: "Mon" | "Mon-Fri" (consecutive range) | "Mon, Wed, Fri" (non-consecutive)
export function formatDays(days: string[]): string {
  if (days.length === 0) return '';

  const sorted = [...days].sort(
    (a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b)
  );

  if (sorted.length === 1) return DAY_ABBR[sorted[0]];

  const startIdx = DAY_ORDER.indexOf(sorted[0]);
  const endIdx = DAY_ORDER.indexOf(sorted[sorted.length - 1]);

  if (endIdx - startIdx === sorted.length - 1) {
    return `${DAY_ABBR[sorted[0]]}-${DAY_ABBR[sorted[sorted.length - 1]]}`;
  }

  return sorted.map(d => DAY_ABBR[d]).join(', ');
}

export function formatTimeDisplay(isoString: string): string {
  try {
    return new Date(isoString).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return '';
  }
}
